import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

import { User, UserMessage } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersMutations, UsersState } from '@/stores/users.store';
import { format } from 'date-fns';
import { computed, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMessages',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { us: UsersState }>();
const messages = computed<UserMessage[]>(() => store.state.us.userMessages);
const loaded = ref<boolean>(false);

const props = __props;

function loadMessages() {
  store.dispatch(UsersActions.GetMessages, props.user.id);
  loaded.value = true;
}

watch(
  () => props.user,
  () => {
    store.commit(UsersMutations.SetMessages, []);
    loaded.value = false;
  },
);

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Date', key: 'creationDate', width: '20%' },
  { title: 'Type', key: 'type', width: '10%' },
  { title: 'Text', key: 'messageText', width: '55%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.user.id !== -1)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Messages")
            ])),
            _: 1
          }),
          (!messages.value.length && !loaded.value)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: loadMessages,
                    color: "info",
                    density: "compact"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("See user messages")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    items: messages.value,
                    headers: headers
                  }, {
                    "item.creationDate": _withCtx(({ value }) => [
                      _createTextVNode(_toDisplayString(_unref(format)(value, 'dd-MM-yyyy - HH:mm')), 1)
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})